import { Link } from 'react-router-dom';

// Credentials line approved by Linus. Keep it to these facts.
export const AUTHOR_CREDENTIALS = 'Built 400+ dashboards. Certified in Sigma, Snowflake, Tableau, and Power BI.';

export default function AuthorBox({ className = '' }: { className?: string }) {
  return (
    <section aria-label="About the author" className={`flex items-start gap-4 rounded-2xl border border-slate-200 bg-white p-5 ${className}`}>
      <img
        src="/images/linus-tse-linkedin-photo.jpeg"
        alt=""
        width="56"
        height="56"
        loading="lazy"
        decoding="async"
        className="h-14 w-14 flex-none rounded-full object-cover"
      />
      <div className="min-w-0 text-[15px] leading-relaxed">
        <p className="font-semibold text-slate-950">Linus Tse</p>
        <p className="text-slate-600">Founder of Greyfield Data. {AUTHOR_CREDENTIALS}</p>
        <Link to="/linus-tse-introduction" className="mt-1 inline-flex min-h-[40px] items-center text-sm font-semibold text-[#1a4e94] underline-offset-4 hover:underline">
          About Linus
        </Link>
      </div>
    </section>
  );
}
